module.exports = __webpack_public_path__ + "img/about_swiper5.56643a15.jpg";